import Image from "next/image";
import Link from "next/link";
import HoverArrow from "@/components/shared/HoverArrow";
import { authorInitials, authorPath, type Author } from "@/lib/authors";

/**
 * "Geschrieben von"-Karte am Ende von Blog-, Lexikon- und Uni-Detailseiten:
 * Bild + Name, verlinkt auf die Autorenseite mit allen Beiträgen (E-E-A-T:
 * Autorschaft muss für Leser:innen und Crawler nachvollziehbar sein).
 */
export default function AuthorCard({
  author,
  className = "",
}: {
  author: Author;
  className?: string;
}) {
  return (
    <Link
      href={authorPath(author.slug)}
      className={`group flex items-center gap-4 py-3 transition-colors ${className}`}
    >
      {author.image ? (
        <Image
          src={author.image}
          alt={author.name}
          width={56}
          height={56}
          className="w-14 h-14 rounded-full object-cover shrink-0"
        />
      ) : (
        <span
          className="w-14 h-14 shrink-0 rounded-full bg-accent-soft text-accent flex items-center justify-center font-display font-bold text-lg"
          aria-hidden="true"
        >
          {authorInitials(author.name)}
        </span>
      )}

      <span className="flex-1 min-w-0">
        <span className="block text-xs font-bold uppercase tracking-widest text-ink-faint mb-0.5">
          Geschrieben von
        </span>
        <span className="block font-display font-semibold text-lg text-ink group-hover:text-accent transition-colors">
          {author.name}
        </span>
        {author.designation && (
          <span className="block text-sm text-ink-soft">{author.designation}</span>
        )}
      </span>

      <span className="hidden sm:inline-flex items-center gap-2 text-sm font-semibold text-accent shrink-0">
        Alle Beiträge
        <HoverArrow size={14} />
      </span>
    </Link>
  );
}
